export const chartConfig = {
  emptyMessages: {
    'message-1': {
      title: '🚀 Ця порожня аналітика чекає на твої рекорди.',
      description: 'Готовий почати?',
    },
    'message-2': {
      title: '📊 Порожня статистика — це можливість побачити, як росте твій професіоналізм у реальному часі.'
    },
    'message-3': {
      title: '🔥 Кожна точка продажу — це твій майбутній пасивний дохід. Створи першу вже зараз.'
    },
    'message-4': {
      title: '🏆 Почни рух — і аналітика оживе.'
    },
  },
};
